@let bgColor = backgroundColor | contentBuilderColor;
@let darkenBgColor = backgroundColor | contentBuilderColor | appDarkenColor;
@if (!(reconstructedShareOrderBasket$ | async)?.length) {
  <div
    class="flex flex-col"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
  >
    @if (title) {
      <div class="px-10 font-accent text-xl font-bold kiosk-xl:mb-5 kiosk-xl:text-4.5xl">
        {{ title }}
      </div>
    }
    @if (reconstructedCart$ | async; as cartByShop) {
      @if (cartByShop.length) {
        <div>
          @for (cart of cartByShop; track cart[reconstructedCartKeys.Shop][shopKeys.Id]) {
            <div>
              <ul class="flex flex-col gap-0 px-0 pb-10 pt-10">
                @for (
                  product of cart[reconstructedCartKeys.Items];
                  track product[reconstructedCartItemKeys.Item][cartItemKeys.Id];
                  let index = $index;
                  let isOdd = $odd
                ) {
                  <li
                    class="flex w-full flex-row items-center gap-8 px-10 py-6 kiosk-xl:py-8 {{
                      isBeingUpdated(product.item.id) &&
                      (product[reconstructedCartItemKeys.Item]?.quantity ?? 0) <= 1
                        ? 'opacity-50'
                        : ''
                    }}"
                    [style.backgroundColor]="isOdd ? darkenBgColor : bgColor"
                  >
                    <div
                      class="relative flex h-[8vw] w-[8vw] min-w-[8vw] items-center rounded-lg kiosk-xl:h-[12vw] kiosk-xl:w-[12vw] kiosk-xl:min-w-[12vw]"
                    >
                      @if (product[reconstructedCartItemKeys.Product]?.images?.thumbnail?.url) {
                        <img
                          class="push-image h-full w-full rounded bg-center object-cover"
                          [src]="product[reconstructedCartItemKeys.Product]?.images?.thumbnail?.url"
                          alt="image"
                        />
                      }
                    </div>
                    <div
                      class="flex w-full flex-row justify-between rounded-l-lg font-bold"
                      [style.backgroundColor]="primaryButtonTextColor | contentBuilderColor"
                      [style.color]="primaryButtonBackgroundColor | contentBuilderColor"
                      [style.backgroundColor]="isOdd ? darkenBgColor : bgColor"
                    >
                      <div
                        class="flex flex-1 flex-row gap-5"
                        (click)="onUpdateItem(product.item.id)"
                      >
                        <div class="flex flex-col justify-center gap-2 text-xl">
                          <span class="font-accent text-xl kiosk-xl:text-3xl"
                            >{{
                              product[reconstructedCartItemKeys.Product]?.[productKeys.Name] ??
                                'INVALID'
                            }}
                          </span>
                          @if (product[reconstructedCartItemKeys.Item]?.additions) {
                            <ul class="list-disc">
                              @for (
                                addition of product[reconstructedCartItemKeys.Item]?.additions;
                                track $index
                              ) {
                                <li class="ml-5 font-normal">
                                  {{ findProductById(cart, addition) }}
                                </li>
                              }
                            </ul>
                          }
                          @for (
                            declinableProduct of product[reconstructedCartItemKeys.Item]?.products
                              | appFn: mergeCartProductQuantities;
                            track declinableProduct
                          ) {
                            <div class="ml-5 font-bold">
                              ● {{ findByIdFromProducts(declinableProduct.id)?.name }} x
                              {{ declinableProduct.quantity }}
                              @if (
                                declinableProduct.additions &&
                                declinableProduct.additions.length > 0
                              ) {
                                @for (addition of declinableProduct.additions; track $index) {
                                  <div class="ml-5 font-normal">
                                    ● {{ findProductById(cart, addition) }}
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="flex flex-row items-center justify-center gap-10">
                        <div class="flex flex-col">
                          <div class="ml-5 min-w-20 text-xl font-bold kiosk-xl:text-3xl">
                            <!-- unit_price from CartService is already in euros (cents / 100); format=false avoids dividing by 100 again (unlike order final_price, which is still in cents). -->
                            <!-- unit_price is already in euros; format=true would treat it as cents and display 1/100 of the value. -->
                            <app-price-atom
                              [amount]="
                                (product[reconstructedCartItemKeys.UnitPrice] ?? 0) *
                                (product[reconstructedCartItemKeys.Item]?.quantity ?? 0)
                              "
                              [format]="false"
                              [bold]="true"
                              stackAlign="end"
                              legalTextClass="text-xl kiosk-xl:text-2xl"
                            ></app-price-atom>
                          </div>
                          @if ((product[reconstructedCartItemKeys.Item]?.quantity ?? 0) > 1) {
                            <div class="ml-5 min-w-20 text-xl font-normal opacity-50">
                              <app-price-atom
                                [amount]="product[reconstructedCartItemKeys.UnitPrice] ?? 0"
                                [format]="false"
                                [bold]="false"
                                legalTextClass="text-lg kiosk-xl:text-xl"
                              ></app-price-atom>
                              /u
                            </div>
                          }
                        </div>
                        <app-counter-atom
                          [type]="'kiosk'"
                          [size]="'XL'"
                          [min]="0"
                          [backgroundColor]="primaryButtonBackgroundColor | contentBuilderColor"
                          [textColor]="primaryButtonTextColor | contentBuilderColor"
                          [(count)]="copyCart(product.item).quantity"
                          (countChange)="changeNbProduct($event, product.item)"
                        ></app-counter-atom>
                      </div>
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    }
  </div>
}
